import api from '../../services/serviceBase'

export default {

    GetUsersByPracticeFilteredByInputForLoggedInUser(practice, input, login, role) {
        return api.execute('get', `/Practice/UsersFilteredByInputForLoggedInUser?practiceCode=${practice}&input=${input}&login=${login}&role=${role}`);
    },
    DeleteUserFromPractice(practice, login) {
        return api.execute('get', `/User/DeleteUserFromPractice?practiceCode=${practice}&login=${login}`);
    }
}